import http from 'hub-http/clients/apiClient';
export function clone(id, definitionCloneInfo = {}, httpClient = http) {
  return httpClient.post(`targeted/v1/definitions/${id}/clone`, {
    data: definitionCloneInfo
  });
}
export function createCombined(data, httpClient = http) {
  return httpClient.post('targeted/v1/definitions/combined', {
    data
  });
}
export function fetch(id, httpClient = http) {
  return httpClient.get(`targeted/v1/definitions/${id}`);
}
export function fetchDefinitions(ids, httpClient = http) {
  const query = {
    id__in: ids
  };
  return httpClient.get('targeted/v1/definitions', {
    query
  });
}